import React from 'react';
import { Box, InputLabel } from '@mui/material';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { Value } from 'react-phone-number-input';

interface PhoneInputWithPlaceholderProps {
	label: string;
	value: string;
	onChange: (value: Value | undefined) => void;
	error?: boolean;
	errorMessage?: string;
	required?: boolean;
	fullWidth?: boolean;
	disabled?: boolean;
	noLabel?: boolean;
}

const PhoneInputWithPlaceholder: React.FC<PhoneInputWithPlaceholderProps> = ({
	label,
	value,
	onChange,
	error = false,
	errorMessage = '',
	required = false,
	fullWidth = false,
	disabled = false,
	noLabel = false,
}) => {
	return (
		<Box sx={{ width: fullWidth ? '100%' : 'auto' }}>
			{!noLabel && <InputLabel variant='standard'>{required ? label + '*' : label}</InputLabel>}
			<Box
				className={`mt-2 ${fullWidth ? 'w-full' : 'w-auto'}`}
				sx={{
					'& .PhoneInputInput': {
						height: '40px',
						padding: '8.5px 14px',
						fontSize: '1rem',
						borderRadius: '4px',
						border: '1px solid rgba(0, 0, 0, 0.23)',
						backgroundColor: disabled ? '#f5f5f5' : 'transparent',
						color: disabled ? 'rgba(0, 0, 0, 0.38)' : 'inherit',
						borderColor: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)',
						'&:focus': {
							borderColor: error ? '#d32f2f' : '#1976d2',
							borderWidth: '2px',
							outline: 'none',
						},
					},
					'& .PhoneInputCountryIcon': {
						borderColor: error ? '#d32f2f' : 'inherit',
					},
				}}
			>
				<PhoneInput
					international
					defaultCountry='AR'
					value={value}
					onChange={onChange}
					disabled={disabled}
					error={error ? errorMessage : undefined}
				/>
			</Box>
			{error && (
				<Box
					component='p'
					className='text-red-600 text-xs mt-1 mr-3.5 mb-0 font-normal leading-relaxed tracking-wide'
					sx={{ fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}
				>
					{errorMessage}
				</Box>
			)}
		</Box>
	);
};

export default PhoneInputWithPlaceholder;
